import { Component } from '@angular/core';

import { MessageBoxService } from '@reg/shared/message-box/message-box.service';
import { MessageBoxButton } from '@reg/shared/message-box/message-box-button.model';
import { MessageBoxOptions } from '@reg/shared/message-box/message-box-options.model';

@Component({
    selector: 'flo-message-box',
    templateUrl: './message-box.component.html',
    styleUrls: ['./message-box.component.scss'],
})
export class MessageBoxComponent {
    public isShown: boolean;
    public title: string;
    public message: string;
    public buttons: MessageBoxButton[] = [];
    public options: MessageBoxOptions;
    public callback: (buttonId: string) => void;
    public zIndex: number = 1051;

    get modalSize(): string {
        if (!this.options || !this.options.size) {
            return 'modal-md';
        }
        if (this.options.size === 'small') {
            return 'modal-sm';
        }
        if (this.options.size === 'medium') {
            return 'modal-md';
        }
        if (this.options.size === 'large') {
            return 'modal-lg';
        }
        return 'modal-md';
    }

    constructor(messageBoxService: MessageBoxService) {
        messageBoxService.showYesNo = this.showYesNo.bind(this);
        messageBoxService.showOK = this.showOK.bind(this);
        messageBoxService.show = this.show.bind(this);
        messageBoxService.hide = this.hide.bind(this);
    }

    public hide(): void {
        this.isShown = false;
        this.callback = null;
    }

    public showYesNo(
        title: string,
        message: string,
        callback: (isYes: boolean) => void,
        options?: MessageBoxOptions,
    ): void {
        this._show(
            title,
            message,
            [new MessageBoxButton('Yes'), new MessageBoxButton('No')],
            (buttonId: string) => {
                if (callback) {
                    callback(buttonId === 'Yes');
                }
            },
            options,
        );
    }

    public showOK(
        title: string,
        message: string,
        callback: (buttonId: string) => void,
        options?: MessageBoxOptions,
    ): void {
        this._show(title, message, [new MessageBoxButton('OK')], callback, options);
    }

    public show(
        title: string,
        message: string,
        buttons: MessageBoxButton[],
        callback: (buttonId: string) => void,
        options?: MessageBoxOptions,
    ): void {
        this._show(title, message, buttons, callback, options);
    }

    public onButtonClick(button: MessageBoxButton): void {
        if (this.callback) {
            this.callback(button.id);
        }

        this.hide();
    }

    private _show(
        title: string,
        message: string,
        buttons: MessageBoxButton[],
        callback: (buttonId: string) => void,
        options?: MessageBoxOptions,
    ): void {
        this.options = options;
        this.title = title;
        this.message = message;
        this.buttons = buttons;
        this.isShown = true;
        this.callback = callback;
        // If other modals are currently open we need to increment the zIndex so they display on top of each other
        this.zIndex = 1051 + (document.querySelectorAll('.modal').length || 0);
    }
}
